<template>
    <path d="M10 2.5c-4.142 0-7.5 3.36-7.5 7.5 0 4.143 3.358 7.5 7.5 7.5 4.142 0 7.5-3.357 7.5-7.5 0-4.14-3.358-7.5-7.5-7.5zm0 13.548c-3.343 0-6.048-2.704-6.048-6.048 0-3.342 2.705-6.048 6.048-6.048 3.341 0 6.048 2.705 6.048 6.048S13.344 16.048 10 16.048zm3.243-7.717c0 2.027-2.19 2.059-2.19 2.808v.192c0 .2-.162.363-.363.363H9.31c-.2 0-.363-.163-.363-.363v-.262c0-1.081.82-1.513 1.439-1.86.53-.298.856-.5.856-.895 0-.522-.665-.868-1.203-.868-.701 0-1.025.332-1.48.906-.123.155-.347.184-.504.065l-.841-.638c-.155-.117-.19-.335-.08-.495.714-1.05 1.624-1.639 3.041-1.639 1.484 0 3.068 1.159 3.068 2.686zm-1.973 5.056c0 .7-.57 1.27-1.27 1.27-.7 0-1.27-.57-1.27-1.27 0-.7.57-1.27 1.27-1.27.7 0 1.27.57 1.27 1.27z" transform="translate(-667 -133) translate(220 104) translate(56 23) translate(389 4)"/>
</template>

<script>
export default {
    name: 'questionCircleIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 16 16');
    }
}
</script>
